import axios from 'axios';
import {BE_SERVER_ENDPOINT, API_PROTOCOL} from '../constants/configs.js';
export const FETCH_WEATHER_DATA_SUCCESS = 'FETCH_WEATHER_DATA_SUCCESS';

export function fetchWeatherData(uuid, measurementType) {
  return dispatch => {
    axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/dashboard/users/' + uuid + '/weather-impact?measurement-type=' + measurementType).then(
      (response) => {
        dispatch({
          type: FETCH_WEATHER_DATA_SUCCESS,
          payload: response.data.payload
        })
      }
    )
  }
}